// VPanel js
require('./logout');
require('./password-criteria-check');
require('./forms');
require('./tooltips');
require('./polyfills/');
require('./vpanel-functions');
require('./vendor-fixes')

if (document.querySelector('header#vpanel-vue-header') && document.querySelector('nav#vpanel-vue-sidebar')) {
    window.vpanel_header_vue_instance = new Vue({
        el: 'header#vpanel-vue-header'
    });

    window.vpanel_sidebar_vue_instance = new Vue({
        el: 'nav#vpanel-vue-sidebar'
    });
}

//Enable Bootstrap plugins
$(function () {
    $('[data-toggle="popover"]').popover();
})

//Disable alert messages for datatables
$.fn.DataTable.ext.errMode = 'throw';
